import { api } from './client';

/** Importar contactos (tanda 3, Ola D). Prefijo /api/importacion, del módulo `importacion`. */
export type Formato = 'csv' | 'xlsx';
export interface Destino {
  clave: string;
  etiqueta: string;
}
export interface FilaLeida {
  linea: number;
  telefono: string;
  nombre: string | null;
  campos: Record<string, string | number>;
}
export interface RevisionDeContactos {
  canal: { id: string; nombre: string };
  columnas: string[];
  destinos: Destino[];
  /** Columna → destino ('' = no se importa). */
  mapeo: Record<string, string>;
  aviso: string | null;
  nuevos: FilaLeida[];
  yaEstan: Array<{ linea: number; telefono: string; nombre: string | null }>;
  bajas: Array<{ linea: number; telefono: string }>;
  malas: Array<{ linea: number; motivo: string }>;
  resumen: { filas: number; nuevos: number; yaEstan: number; bajas: number; malas: number };
}
export interface ResultadoDeContactos {
  creados: number;
  primerosToques: number;
  yaEstan: number;
  bajas: number;
  malas: number;
}

/** CSV: el texto. XLSX: el archivo en base64. */
export const revisarContactos = (b: { archivo: string; formato: Formato; mapeo?: Record<string, string> }) =>
  api.post<RevisionDeContactos>('/api/importacion/contactos/revisar', b);
/** `fuente` (T14): de qué base es el archivo; la llevan los contactos nuevos. */
export const importarContactos = (b: { archivo: string; formato: Formato; mapeo: Record<string, string>; fuente?: string }) =>
  api.post<ResultadoDeContactos>('/api/importacion/contactos', b);
